// src/components/dashboard/StatusBadge.jsx
import styles from './StatusBadge.module.css';

/**
 * Color-coded status badge for tickets.
 * @param {{ status: string }} props
 */
export default function StatusBadge({ status = 'Open' }) {
  const key = (status || '').toLowerCase().replace(/\s+/g, '-');

  return (
    <span className={`${styles.badge} ${styles[key] ?? styles.open}`}>
      {status || 'Open'}
    </span>
  );
}
